export default __webpack_public_path__ + "i18n/translations/translation-hi.3b7ee806.json";